<template>
  <div class="search_container">
    <div class="search_selector">
      <NetworkSelector />
    </div>
    <div class="search_divider" />
    <BaseSvgIcon name="search2" class="search_icon" />
    <input
      ref="searchInput"
      class="search_input"
      type="text"
      :placeholder="placeholder"
      :value="modelValue"
      @input="onInput($event)"
      @keydown="onKeydown"
    />
    <BaseSvgIcon
      v-if="modelValue"
      name="close2"
      class="search_icon search_icon_close"
      @click="clearInput"
    />
  </div>
</template>

<script setup>
import { ref, nextTick } from "vue";
import BaseSvgIcon from "@/shared/ui/BaseSvgIcon/BaseSvgIcon.vue";
import "@/assets/icons/SVG/search2.svg";
import "@/assets/icons/SVG/close2.svg";
import "@/assets/icons/SVG/arrow-up.svg";
import NetworkSelector from "./NetworkSelector.vue";

// Props
defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  modelValue: {
    type: [Number, String],
    default: "",
  },
});

// Emits
const emit = defineEmits(["update:modelValue", "search", "clear"]);

// Template refs
const searchInput = ref(null);

// Methods
const onKeydown = (event) => {
  if (event.key === "Enter") {
    emit("search");
  }
};

const clearInput = () => {
  emit("update:modelValue", "");
  emit("clear");

  // Focus on input after clear
  nextTick(() => {
    searchInput.value.focus();
  });
};

const onInput = (event) => {
  const value = event.target.value;
  emit("update:modelValue", value);
};
</script>

<style lang="scss" scoped>
.search {
  &_container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-radius: 12px;
    width: 100%;
    //border: 1px solid var(--bg-6);
    border: 1px solid #2d2d2d;
    background: var(--bg-3);
    padding: 8px 11px;
    transition: 0.1s all ease-in-out;
    z-index: 0;
    cursor: pointer;

    &:hover:not(:has(.search_selector:hover)) {
      border: 1px solid #575757;
    }

    &:focus-within {
      //border: 1px solid #2D2D2D;
      border: 1px solid #575757;
    }
  }

  &_icon {
    margin-right: 16px;
    min-width: 24px;
    width: 24px;
    height: 24px;
    color: #575757;
    transition: 0.1s all ease-in-out;

    &_close {
      cursor: pointer;
      &:hover {
        color: white;
      }
    }
  }

  &_input {
    padding: 8px;
    all: unset;
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;

    &::placeholder {
      color: #7a7a7a;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }
  }

  &_selector {
    position: relative;
    z-index: 2;
    &-text {
      white-space: nowrap;
      line-height: 150%;
      font-size: 14px;
      font-weight: 500;
    }
  }

  &_divider {
    margin-right: 16px;
    width: 1px;
    height: 24px;
    background: #2d2d2d;
  }
}
</style>
